var map = {
	"./fortuneIcon.svg": 697,
	"./fortuneIconL.svg": 698,
	"./helpdeskIcon.svg": 699,
	"./helpdeskIconL.svg": 700,
	"./homeIcon.svg": 701,
	"./homeIconLarge.svg": 702,
	"./jackpotIcon.svg": 703,
	"./logo.svg": 704,
	"./logoSmall.svg": 705,
	"./loyaltyIcon.svg": 706,
	"./mobileAppIcon.svg": 707,
	"./profileIcon.svg": 708,
	"./questIcon.svg": 709,
	"./questsIcon.svg": 710,
	"./rewardLineupIcon.svg": 711,
	"./searchIcon.svg": 712,
	"./searchIconLarge.svg": 713,
	"./signOutIcon.svg": 714,
	"./star.svg": 715,
	"./tournamentIcon.svg": 716,
	"./tournamentLargeIcon.svg": 717,
	"./vipIcon.svg": 718,
	"./wheelIcon.svg": 719,
	"./wheelIconL.svg": 720,
	"./wheelIconMobile.svg": 721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 696;